// extracted by mini-css-extract-plugin
module.exports = {"printable":"styles_printable__QZkIk","nonPrintable":"styles_nonPrintable__cS4um","promotion":"styles_promotion__cvuPL"};